import { render, staticRenderFns } from "./BlockType23SmallRow.vue?vue&type=template&id=3596d13f&scoped=true"
import script from "./BlockType23SmallRow.vue?vue&type=script&lang=ts"
export * from "./BlockType23SmallRow.vue?vue&type=script&lang=ts"
import style0 from "./BlockType23SmallRow.vue?vue&type=style&index=0&id=3596d13f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3596d13f",
  null
  
)

export default component.exports